export default __webpack_public_path__ + "static/media/metamask.645c1954.svg";